var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"top-banner"},[_c('parallax',{attrs:{"sectionHeight":"198px","imgHeight":"auto","speedFactor":0.25}},[_c('img',{attrs:{"src":_vm.bannerURL,"alt":_vm.$cms.utils.getComputedLabel(_vm.labels.bannerAlt)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }